import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|History|Fulfillment|Release|';
const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.CredentialFulfillment,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateHistoryFulfillmentRelease';
export type SPCandidateHistoryFulfillmentReleaseLocNames =
	| `${LocNameStart}TitleTab`
	| `${LocNameStart}TitlePage`
	| `${LocNameStart}ButtonCancel`
	| `${LocNameStart}ButtonReleaseAll`
	| `${LocNameStart}LabelName`
	| `${LocNameStart}LabelFulfillmentType`
	| `${LocNameStart}LabelFilterFulfillmentType`
	| `${LocNameStart}ButtonReleaseOne`
	| `${LocNameStart}NotificationReleaseSuccess`
	| `${LocNameStart}NotificationReleaseError`;

export const spCandidateHistoryFulfillmentReleaseLocs: LocDefs<SPCandidateHistoryFulfillmentReleaseLocNames> =
	{
		SPCandidateHistoryFulfillmentReleaseTitleTab: {
			defaultValue: 'Release Fulfillments',
			description: 'Tab Title',
			displayPath: `${pathStart}Tab Title`,
			displayType: 'Title',
			legacyName: 'Credential.Fulfillment/Candidates.FulfillmentRelease.Title.Tab',
			...sharedProperties,
		},
		SPCandidateHistoryFulfillmentReleaseTitlePage: {
			defaultValue: 'Fulfillment Delivery Information',
			description: 'Page Title',
			displayPath: `${pathStart}Page Title`,
			displayType: 'Title',
			legacyName:
				'Credential.Fulfillment/Candidates.FulfillmentRelease.Title.ReleaseFullfilment',
			...sharedProperties,
		},
		SPCandidateHistoryFulfillmentReleaseButtonCancel: {
			defaultValue: 'Cancel',
			description: 'Cancel button text',
			displayPath: `${pathStart}Cancel Button`,
			displayType: 'Button',
			legacyName: 'Credential.Fulfillment/Candidates.FulfillmentRelease.Button.Cancel',
			...sharedProperties,
		},
		SPCandidateHistoryFulfillmentReleaseButtonReleaseAll: {
			defaultValue: 'Release All Fulfillments',
			description: 'Release All Fulfillments button text',
			displayPath: `${pathStart}Release All Button`,
			displayType: 'Button',
			legacyName: 'Credential.Fulfillment/Candidates.FulfillmentRelease.Button.Release',
			...sharedProperties,
		},
		SPCandidateHistoryFulfillmentReleaseLabelName: {
			defaultValue: 'Name',
			description: 'Column heading for Name',
			displayPath: `${pathStart}Name`,
			displayType: 'Label',
			legacyName: 'Credential.Fulfillment/Candidates.FulfillmentQueue.ColumnHeading.Name',
			...sharedProperties,
		},
		SPCandidateHistoryFulfillmentReleaseLabelFulfillmentType: {
			defaultValue: 'Fulfillment Type',
			description: 'Column heading for Fulfillment Type',
			displayPath: `${pathStart}Fulfillment Type`,
			displayType: 'Label',
			legacyName:
				'Credential.Fulfillment/Candidates.FulfillmentQueue.ColumnHeading.FulfillmentType',
			...sharedProperties,
		},
		SPCandidateHistoryFulfillmentReleaseLabelFilterFulfillmentType: {
			defaultValue: 'Filter by Fulfillment Type',
			description: 'Field label for filtering by Fulfillment Type',
			displayPath: `${pathStart}Filter by Fulfillment Type`,
			displayType: 'Label',
			legacyName:
				'Credential.Fulfillment/Candidates.FulfillmentQueue.FieldLabel.FilterFulfillmentType',
			...sharedProperties,
		},
		SPCandidateHistoryFulfillmentReleaseButtonReleaseOne: {
			defaultValue: 'Release Fulfillment',
			description: 'Button text for releasing one fulfillment',
			displayPath: `${pathStart}Release Fulfillment`,
			displayType: 'Button',
			legacyName: 'Credential.Fulfillment/Candidates.FulfillmentRelease.Button.ReleaseOne',
			...sharedProperties,
		},
		SPCandidateHistoryFulfillmentReleaseNotificationReleaseSuccess: {
			defaultValue: 'Fulfillments successfully released',
			description: 'Notification message for successful release',
			displayPath: `${pathStart}Fulfillments successfully released`,
			displayType: 'Notification',
			legacyName:
				'Credential.Fulfillment/Candidates.FulfillmentRelease.Notification.ReleaseSuccess',
			...sharedProperties,
		},
		SPCandidateHistoryFulfillmentReleaseNotificationReleaseError: {
			defaultValue: 'There was an error releasing fulfillments.',
			description: 'Notification message for release error',
			displayPath: `${pathStart}Releasing fulfillments error`,
			displayType: 'Notification',
			legacyName:
				'Credential.Fulfillment/Candidates.FulfillmentRelease.Notification.ReleaseError',
			...sharedProperties,
		},
	};

export type SPCandidateHistoryFulfillmentReleaseLocType =
	LocMap<SPCandidateHistoryFulfillmentReleaseLocNames>;
